<div class="icon-badge-wrapper" title="AI tasks processing">
	<i
		class="pi pi-spinner icon-with-badge cursor-pointer"
		[attr.title]="
    (count
      ? count + ' AI task' + (count === 1 ? '' : 's') + (count === 1 ? ' is' : ' are') + ' being processed'
      : 'No AI tasks processing'
    ) + ' \n — double-click to refresh'
  "
		[class]="iconSizeClass"
		[class.pi-spin]="isRefreshing"
		[style.color]="(isRefreshing) ? activeColor : null"
		(click)="togglePanel($event)"
		(dblclick)="refreshNow()"
	>
	</i>
	<span *ngIf="count > 0" class="badge">{{ count }}</span>
</div>

<p-overlayPanel #panel [dismissable]="true" [showCloseIcon]="true" appendTo="body">
	<div class="min-w-[260px] p-0 border-round-md">
		<ng-container *ngIf="tasks.length > 0; else noTasks" class="p-0">
			<div class="font-medium mb-2 text-xs font-semibold bg-primary p-2">Processing tasks</div>
			<ul class="list-none m-0 p-0 text-xs">
				<li class="py-2 border-b last:border-none" *ngFor="let t of tasks">
					{{ t.name }}
				</li>
			</ul>
		</ng-container>
		<ng-template #noTasks>
			<div class="py-2 text-sm opacity-70">No AI tasks processing.</div>
		</ng-template>
	</div>
</p-overlayPanel>
